export interface ExperienceItem {
  title: string;
  image: string;
  description: string;
  price?: string;
  duration?: string;
}

export interface ExperienceCategory {
  title: string;
  items: ExperienceItem[];
}

export const experiencesData: ExperienceCategory[] = [
  {
    title: "Adventure & Nature",
    items: [
      {
        title: "ATV Adventure",
        image: "/media/activities/atv-adventure.webp",
        description: "Experience the thrill of riding an ATV through the beautiful landscapes of Bali.",
      },
      {
        title: "Cycling Tour",
        image: "/media/activities/cycling-tour.webp",
        description: "Cycle through lush rice paddies and traditional villages on a guided tour.",
      },
      {
        title: "Rice Terrace Walking Tour",
        image: "/media/activities/walking-tour.webp",
        description: "Take a peaceful stroll through some of the most iconic rice terraces in the world.",
      },
      {
        title: "Sunrise Jeep Mount Batur",
        image: "/media/activities/batur-jeep-tour.webp",
        description: "Witness a breathtaking sunrise from Mount Batur without the early morning hike.",
      },
      {
        title: "Scooter Tour",
        image: "/media/activities/scooter-tour.webp",
        description: "Explore the hidden gems of Sidemen on a thrilling guided scooter tour.",
      },
      {
        title: "Rafting",
        image: "/media/activities/rafting.webp",
        description: "Experience the adrenaline rush of white water rafting down the Ayung River.",
      },
      {
        title: "Batur Trekking",
        image: "/media/activities/batur-trekking.webp",
        description: "Hike up the active volcano of Mount Batur and watch the sunrise from the summit.",
      },
      {
        title: "Waterfall Tour",
        image: "/media/activities/waterfall-tour.webp",
        description: "Visit some of the most stunning and hidden waterfalls in the Sidemen area.",
      },
      {
        title: "Swing",
        image: "/media/activities/swing.webp",
        description: "Experience the adrenaline of swinging high above the stunning valleys and jungles of Bali.",
      },
      {
        title: "Mount Agung Trekking",
        image: "/media/activities/mount-agung-trekking.webp",
        description: "Challenge yourself with a rewarding sunrise trek to the highest peak in Bali, Mount Agung.",
      }
    ]
  },
  {
    title: "Culture & Art",
    items: [
      {
        title: "Cooking Class",
        image: "/media/activities/cooking-class.webp",
        description: "Learn the secrets of authentic Balinese cuisine with our expert local chefs.",
      },
      {
        title: "Silver Class",
        image: "/media/activities/silver-class.webp",
        description: "Create your own unique silver jewelry guided by traditional silversmiths.",
      },
      {
        title: "Coffee Plantation Tour",
        image: "/media/activities/coffee-plantation-tour.webp",
        description: "Discover the process of making traditional Balinese coffee, including the famous Luwak coffee.",
      }
    ]
  },
  {
    title: "Wellness & Spiritual",
    items: [
      {
        title: "Yoga & Wellness",
        image: "/media/activities/yoga-wellness.webp",
        description: "Rejuvenate your mind and body with our guided yoga and wellness sessions.",
      }
    ]
  }
];
